export default __webpack_public_path__ + "static/experienceImg6-99aa280ad1eccf064fecfeefffbf44b5.webp";